export default "__VITE_ASSET__Gf4HiiWN__"